import { IsArray, IsBoolean, IsIn, IsMongoId, IsString, ValidateNested, IsNotEmpty, IsNumber, IsOptional, ArrayMinSize, ValidateIf } from "class-validator";
import { IPaymentMethod, PaymentProvider } from "../interfaces";
import { MongodbRelationId } from "./utils.dto";
import { Type } from "class-transformer";

class PaymentProviderShopDTO {
  @IsNotEmpty({ message: 'Le restaurant associé au prestataire de paiement est requis' })
  @IsMongoId()
  _id: string;

  @IsOptional()
  @IsString()
  shopId?: string;

  @IsOptional()
  @IsNumber()
  fees?: number;
}

export class PaymentProviderDTO {

  @IsNotEmpty({ message: 'Le type de prestataire de paiement est requis' })
  @IsIn([PaymentProvider.PAYGREEN, PaymentProvider.WORLDLINE], { message: 'Le type de prestataire de paiement est invalide' })
  type: PaymentProvider.PAYGREEN | PaymentProvider.WORLDLINE;

  @IsNotEmpty({ message: 'Les restaurants associées au prestataire de paiement sont requises' })
  @IsArray({ message: 'Les restaurants associées au prestataire de paiement sont requises' })
  @ArrayMinSize(1, { message: 'Au moins une boutique est requise' })
  @ValidateNested({ each: true, message: 'Les restaurants associées au prestataire de paiement sont requises' })
  @Type(() => PaymentProviderShopDTO)
  shops: PaymentProviderShopDTO[];

  @IsNotEmpty({ message: 'Les moyens de paiement associées au prestataire de paiement sont requises' })
  @IsArray({ message: 'Les moyens de paiement associées au prestataire de paiement sont requises' })
  @ArrayMinSize(1, { message: 'Au moins un moyen de paiement est requise' })
  @ValidateNested({ each: true, message: 'Les moyens de paiement associées au prestataire de paiement sont requises' })
  @Type(() => MongodbRelationId)
  paymentMethods: Pick<IPaymentMethod, '_id'>[];

  // Paygreen specific fields
  @ValidateIf((o) => o.type === PaymentProvider.PAYGREEN)
  @IsNotEmpty({ message: 'L\'identifiant boutique est requis' })
  @IsString({ message: 'L\'identifiant boutique est requis' })
  rootShopId?: string;

  @ValidateIf((o) => o.type === PaymentProvider.PAYGREEN)
  @IsNotEmpty({ message: 'Le marketplace du prestataire de paiement est requise' })
  @IsBoolean({ message: 'Le marketplace du prestataire de paiement est requise' })
  marketplace?: boolean;

  @ValidateIf((o) => o.type === PaymentProvider.PAYGREEN)
  @IsNotEmpty({ message: 'La clé publique est requise' })
  @IsString({ message: 'La clé publique est requise' })
  publicKey?: string;

  @ValidateIf((o) => o.type === PaymentProvider.PAYGREEN)
  @IsNotEmpty({ message: 'La clé secrète est requise' })
  @IsString({ message: 'La clé secrète est requise' })
  secretKey?: string;

  // Worldline specific fields
  @ValidateIf((o) => o.type === PaymentProvider.WORLDLINE)
  @IsNotEmpty({ message: 'L\'identifiant marchand est requis' })
  @IsString({ message: 'L\'identifiant marchand est requis' })
  merchantId?: string;

  @ValidateIf((o) => o.type === PaymentProvider.WORLDLINE)
  @IsNotEmpty({ message: 'La clé API est requise' })
  @IsString({ message: 'La clé API est requise' })
  apiKey?: string;

  @ValidateIf((o) => o.type === PaymentProvider.WORLDLINE)
  @IsNotEmpty({ message: 'Le secret API est requis' })
  @IsString({ message: 'Le secret API est requis' })
  apiSecret?: string;

}
